export var SPINNER_ELEMENT = /* @__PURE__ */ ((SPINNER_ELEMENT2) => {
  SPINNER_ELEMENT2["ARROW"] = "arrow";
  SPINNER_ELEMENT2["HUBCAP"] = "hubcap";
  SPINNER_ELEMENT2["WHEEL"] = "wheel";
  SPINNER_ELEMENT2["FREE_GIFT"] = "freeGift";
  SPINNER_ELEMENT2["DISCOUNT"] = "discount";
  return SPINNER_ELEMENT2;
})(SPINNER_ELEMENT || {});
